import logo from './img/sheets.png';
import lamps1 from './img/lamps1.png';
import lamps2 from './img/lamps2.png';
import lamps3 from './img/lamps3.png';
import aboutTextEn from './img/about_text_en.png';
import aboutTextRu from './img/about_text_ru.png';
import stand from './img/stand.png';
import bg from './img/lottery.jpg';
import card from './img/card.jpg';
import fnt from './font/TTWPGOTT.woff2';
import React from 'react';
import Icon from '@material-ui/core/Icon';
import cases from './data.json';
import './App.css';
import RiseLoader from "react-spinners/RiseLoader";
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramIcon,
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon
} from "react-share";

function App() {

  //check url params for "shared" property and set it as initial state
  var qs = require('qs');
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl).toString();
  var sharedId = qs.parse(params).shared;
  //console.log("shared card!!!  " + sharedCard);
  var sharedCard = (sharedId !== undefined) ? cases.find(element => element.id === sharedId) : undefined;
  var initState = sharedCard !== undefined ?
    { isLoading: true, isCard: true, isAboutEn: false, isAboutRu: false, card: sharedCard }
    : { isLoading: true, isCard: false, isAboutEn: false, isAboutRu: false };

  //initial state of component
  const [stateData, setShowResults] = React.useState(initState)

  function fullUrl(rel) {
    console.log("preload: " + window.location.origin + rel);
    return window.location.origin + rel;
  }

  React.useEffect(() => {
    const imagesMain = [
      fullUrl(bg),
      fullUrl(logo),
      fullUrl(stand),
      fullUrl(card)

    ];
    const imagesMore = [
      fullUrl(lamps1),
      fullUrl(lamps2),
      fullUrl(lamps3),
      fullUrl(aboutTextEn),
      fullUrl(aboutTextRu),
    ];

    var head = document.head;
    var link = document.createElement("link");

    link.type = "font/woff2";
    link.rel = "preload";
    link.as = "font";
    link.href = fullUrl(fnt);
    link.crossorigin = "anonymous";

    head.appendChild(link);

    cacheData(imagesMain, imagesMore);
  }, [stateData.isLoading]);

  const cacheData = async (srcArrayBefore, srcArrayAfter) => {
    const promisesBefore = await srcArrayBefore.map((src) => {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          console.log("loaded ");
          resolve()
        };
        img.onerror = () => {
          console.log("rejected ");
          reject()
        };
      });
    });
    const promisesAfter = await srcArrayAfter.map((src) => {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          console.log("loaded ");
          resolve()
        };
        img.onerror = () => {
          console.log("rejected ");
          reject()
        };
      });
    });
    await Promise.all(promisesBefore);

    setShowResults({ isLoading: false, isCard: false, isAboutEn: false, isAboutRu: false })

    await Promise.all(promisesAfter);
  };


  function getShareUrl(val) {
    return "https://lotto-by.web.app";
  }
  function getShareText(val) {
    return val.prelude
      + " "
      + val.quote
      + "\n"
      + val.prelude_alt
      + " "
      + val.quote_alt
  }


  const Card = (props) => (
    <div id="card" className="card">
      <div className="headerLine"><span className="refresh"><Icon id="refresh" onClick={openCardClick}>sync</Icon></span><span className="closeX"><Icon id="close" onClick={openCardClick}>close</Icon></span></div><br />
      <div className="headerLine"><span className="leftAlign">№ {props.value.id}</span> <span className="rightAlign">LOTTERY:BORN IN BELARUS</span></div>
      <div>
        <br />
        {props.value.prelude}<br /><br />
        {props.value.quote}<br />
        <br />
        {props.value.prelude_alt}<br /><br />
        {props.value.quote_alt}<br /><br />
        <div className="centerAlign"></div>
      </div><br />
      <FacebookShareButton
        url={getShareUrl(props.value)}
        quote={getShareText(props.value)}
        className="share-button">
        <FacebookIcon size={34} round={true} iconFillColor="black" bgStyle={{ fill: "none" }} />
      </FacebookShareButton>
      <TwitterShareButton
        url={getShareUrl(props.value)}
        title={getShareText(props.value)}
        className="share-button">
        <TwitterIcon size={34} round={true} iconFillColor="black" bgStyle={{ fill: "none" }} />
      </TwitterShareButton>
      <TelegramShareButton
        url={getShareUrl(props.value)}
        title={getShareText(props.value)}
        className="share-button">
        <TelegramIcon size={32} round={true} iconFillColor="black" bgStyle={{ fill: "none" }} />
      </TelegramShareButton>
      <WhatsappShareButton
        url={getShareUrl(props.value)}
        title={getShareText(props.value)}
        separator=":: "
        className="share-button">
        <WhatsappIcon size={32} round iconFillColor="black" bgStyle={{ fill: "none" }} />
      </WhatsappShareButton>
      <span className="closeX" onClick={openCardClick} id="aboutEn">{'\u00A0'}about{'\u00A0'}</span>
      <span className="closeX" onClick={openCardClick} id="aboutRu">{'\u00A0'}о проекте{'\u00A0'}</span>
    </div>
  )

  const AboutEn = (props) => (
    <img src={aboutTextEn} className="aboutImg" id="close" onClick={openCardClick} alt="about" />
  );
  const AboutRu = (props) => (
    <img src={aboutTextRu} className="aboutImg" id="close" onClick={openCardClick} alt="about" />
  );


  function openCardClick(e) {
    console.log("click target id = " + e.target.id);
    if (e.target.id === "aboutEn") {
      console.log("! Opening about");
      setShowResults({ isLoading: false, isCard: false, isAboutEn: true, isAboutRu: false })
      return;
    }
    if (e.target.id === "aboutRu") {
      console.log("! Opening about");
      setShowResults({ isLoading: false, isCard: false, isAboutEn: false, isAboutRu: true })
      return;
    }
    if (e.target.id === "close") {
      console.log("! Closing all");
      setShowResults({ isLoading: false, isCard: false, isAboutEn: false, isAboutRu: false })
      return;
    }
    if ((e.target.id === "stand" && !stateData.isCard) || e.target.id === "refresh") {
      console.log("! Opening card");
      var randomIndex = Math.floor(Math.random() * cases.length);
      var jsonVal = cases[randomIndex];
      //skip offensive sentence 
      if (jsonVal.id === 93)
      {
        jsonVal = cases[randomIndex+1];
      }
      console.log("val: {" + jsonVal.id + "} " + jsonVal.quote);
      setShowResults({ isLoading: false, isCard: true, isAboutEn: false, isAboutRu: false, card: jsonVal })
    }
  }

  return (
    <div className="App">
      {stateData.isLoading
        ? <div className="loadr" ><RiseLoader size="20px" loading="true" color="red" /></div>
        :
        <div className="App-container">
          <img src={logo} className="sheets2" alt="logo" />
          <img src={logo} className="sheets" alt="sheets" />
          <img src={lamps1} className="lamps1" alt="lamps" />
          <img src={lamps2} className="lamps2" alt="lamps" />
          <img src={lamps3} className="lamps3" alt="lamps" />
          <img src={stand} className="stand" alt="stand" id="stand" onClick={openCardClick} />

          {stateData.isCard ? <Card value={stateData.card} /> : null}
          {stateData.isAboutEn ? <AboutEn /> : null}
          {stateData.isAboutRu ? <AboutRu /> : null}
        </div>}
    </div>
  );


}
export default App;